/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './blood-donation.reducer';

export const BloodDonation = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const bloodDonationList = useAppSelector(state => state.bloodDonation.entities);
  const loading = useAppSelector(state => state.bloodDonation.loading);
  const totalItems = useAppSelector(state => state.bloodDonation.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="blood-donation-heading" data-cy="BloodDonationHeading">
        <Translate contentKey="tinyMedicRestApp.bloodDonation.home.title">Blood Donations</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.bloodDonation.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/blood-donation/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.bloodDonation.home.createLabel">Create new Blood Donation</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.bloodDonation.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {bloodDonationList && bloodDonationList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('baggedDate')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.baggedDate">Bagged Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('baggedDate')} />
                </th>
                <th className="hand" onClick={sort('bagNo')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.bagNo">Bag No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bagNo')} />
                </th>
                <th className="hand" onClick={sort('consentDate')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.consentDate">Consent Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consentDate')} />
                </th>
                <th className="hand" onClick={sort('consentNo')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.consentNo">Consent No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consentNo')} />
                </th>
                <th className="hand" onClick={sort('bloodType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.bloodType">Blood Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodType')} />
                </th>
                <th className="hand" onClick={sort('rhType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.rhType">Rh Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rhType')} />
                </th>
                <th className="hand" onClick={sort('tubeID')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.tubeID">Tube ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tubeID')} />
                </th>
                <th className="hand" onClick={sort('collectDate')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.collectDate">Collect Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('collectDate')} />
                </th>
                <th className="hand" onClick={sort('startTime')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.startTime">Start Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startTime')} />
                </th>
                <th className="hand" onClick={sort('endTime')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.endTime">End Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endTime')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('extracted')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.extracted">Extracted</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('extracted')} />
                </th>
                <th className="hand" onClick={sort('extractedAt')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.extractedAt">Extracted At</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('extractedAt')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.donor">Donor</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.donationType">Donation Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.bagType">Bag Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.approval">Approval</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.fitness">Fitness</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.bank">Bank</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodDonation.collectedCamp">Collected Camp</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bloodDonationList.map((bloodDonation, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/blood-donation/${bloodDonation.id}`} color="link" size="sm">
                      {bloodDonation.id}
                    </Button>
                  </td>
                  <td>{bloodDonation.baggedDate}</td>
                  <td>{bloodDonation.bagNo}</td>
                  <td>{bloodDonation.consentDate}</td>
                  <td>{bloodDonation.consentNo}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BloodGroup.${bloodDonation.bloodType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.RhType.${bloodDonation.rhType}`} />
                  </td>
                  <td>{bloodDonation.tubeID}</td>
                  <td>{bloodDonation.collectDate}</td>
                  <td>{bloodDonation.startTime}</td>
                  <td>{bloodDonation.endTime}</td>
                  <td>{bloodDonation.active ? 'true' : 'false'}</td>
                  <td>{bloodDonation.cursor}</td>
                  <td>{bloodDonation.lastUpdated}</td>
                  <td>{bloodDonation.microSec}</td>
                  <td>{bloodDonation.timestampEntry}</td>
                  <td>{bloodDonation.extracted ? 'true' : 'false'}</td>
                  <td>{bloodDonation.extractedAt}</td>
                  <td>{bloodDonation.notes}</td>
                  <td>{bloodDonation.donor ? <Link to={`/gluco-user/${bloodDonation.donor.id}`}>{bloodDonation.donor.id}</Link> : ''}</td>
                  <td>
                    {bloodDonation.donationType ? (
                      <Link to={`/clinical-dictionary/${bloodDonation.donationType.id}`}>{bloodDonation.donationType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodDonation.bagType ? (
                      <Link to={`/clinical-dictionary/${bloodDonation.bagType.id}`}>{bloodDonation.bagType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodDonation.approval ? (
                      <Link to={`/clinical-dictionary/${bloodDonation.approval.id}`}>{bloodDonation.approval.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodDonation.fitness ? (
                      <Link to={`/blood-donor-fitness/${bloodDonation.fitness.id}`}>{bloodDonation.fitness.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{bloodDonation.bank ? <Link to={`/blood-bank/${bloodDonation.bank.id}`}>{bloodDonation.bank.id}</Link> : ''}</td>
                  <td>
                    {bloodDonation.collectedCamp ? (
                      <Link to={`/health-camp/${bloodDonation.collectedCamp.id}`}>{bloodDonation.collectedCamp.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/blood-donation/${bloodDonation.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/blood-donation/${bloodDonation.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/blood-donation/${bloodDonation.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.bloodDonation.home.notFound">No Blood Donations found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={bloodDonationList && bloodDonationList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BloodDonation;
